import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined'
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined'
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined'
import PsychologyIcon from '@mui/icons-material/Psychology'
import EventNoteIcon from '@mui/icons-material/EventNote'
import DevicesIcon from '@mui/icons-material/Devices'
import FavoriteIcon from '@mui/icons-material/Favorite'
import EmojiEmotionsIcon from '@mui/icons-material/EmojiEmotions'
import AssessmentIcon from '@mui/icons-material/Assessment'
import LocalOfferIcon from '@mui/icons-material/LocalOffer'
import { useState } from 'react'
import { APP_CONSTANTS } from 'src/consumer/constants'
import { PublicAppFooter } from '../PublicAppFooter'
import PublicAppHeader from '../PublicAppHeader'
import { ClubbedAuthModal } from '../SignIn/ClubbedAuthComponents'
import {
  HCContainerLevelOne,
  HCContainerLevelTwo,
  HCItemContainer,
  HCItemHeading,
  HCItemHeadingH1,
  HCSubheading,
  HCItemText,
  HCItemTalkToUsALink,
  HCItemTalkToUsContainer,
  HCItemTalkToUsIconContainer,
  HCIconWrapper,
  HCTalkToUsHeader,
  HCTalkToUsContent,
  HCTalkToUsActions,
  HCTalkToUsFooter,
} from './HelpCenterStyles'
import { SEOComponent } from 'src/consumer/helpers/utilFunctions'
import helpCenterCategories from './helpCenterCategories.json'

export default function HelpCenter({ embedded }) {
  const [showClubbedAuthModal, setShowClubbedAuthModal] = useState(false)
  const [typeOfClubbedAuthModal, setTypeOfClubbedAuthModal] = useState('login')
  console.log(embedded)
  return (
    <>
      {Boolean(embedded) ? (
        <></>
      ) : (
        <PublicAppHeader
          config={{ showLinks: false }}
          loginFunction={() => {
            setTypeOfClubbedAuthModal('login')
            setShowClubbedAuthModal(true)
          }}
          registerFunction={() => {
            setTypeOfClubbedAuthModal('signup')
            setShowClubbedAuthModal(true)
          }}
        />
      )}
      <ClubbedAuthModal
        open={showClubbedAuthModal}
        onClose={() => setShowClubbedAuthModal(false)}
        loginVariant={typeOfClubbedAuthModal === 'login'}
      />
      <SEOComponent
        title="Help Center | AUMHUM"
        description={
          "Welcome to the AUMHUM Help Centre. We're here to support you every step of the way. Explore our FAQs, guides, or contact us for personalized assistance."
        }
        image={APP_CONSTANTS.APP_LOGO_LINK}
        keywordsArr={['help', 'center', 'support']}
      />
      <HCContainerLevelOne>
        <HCItemHeadingH1>Help Center</HCItemHeadingH1>
        <HCSubheading>
          Find answers to common questions and learn how to make the most of your mental wellness journey
        </HCSubheading>
        <HCContainerLevelTwo>
          {helpCenterCategories.map((category) => (
            <HCCategoryItem
              key={category.faqCategoryId}
              embedded={embedded}
              faqCategoryId={category.faqCategoryId}
              heading={category.heading}
              description={category.description}
              icon={getHelpCenterCategoryIcon(category.faqCategoryId)}
            />
          ))}
        </HCContainerLevelTwo>
      </HCContainerLevelOne>

      {Boolean(embedded) ? (
        <></>
      ) : (
        <HCContainerLevelOne>
          <HCItemHeading>Still need help?</HCItemHeading>
          <HCTalkToUsCard />
        </HCContainerLevelOne>
      )}
      {Boolean(embedded) ? <></> : <PublicAppFooter />}
    </>
  )
}

function getHelpCenterCategoryIcon(faqCategoryId) {
  const iconClassName = 'category-icon'
  const iconMap = {
    'faq-category-c1ca53b66e75417d94cf3375fb608dbc': (
      <PsychologyIcon className={iconClassName} />
    ),
    'faq-category-bbc3330df369435086fd32b7aee8e2c9': (
      <EventNoteIcon className={iconClassName} />
    ),
    'faq-category-c487d0237e2f45be85518c31fae426f2': (
      <DevicesIcon className={iconClassName} />
    ),
    'faq-category-209177baf22e49eaa98631eea1573756': (
      <FavoriteIcon className={iconClassName} />
    ),
    'faq-category-433d85963ca14c60a1c120207c838a6a': (
      <EmojiEmotionsIcon className={iconClassName} />
    ),
    'faq-category-f98ba83bcc48451ab64f38adf34a6c2b': (
      <AssessmentIcon className={iconClassName} />
    ),
    'faq-category-d6e538660b8c498e87431703145159b2': (
      <LocalOfferIcon className={iconClassName} />
    ),
  }

  return iconMap[faqCategoryId] || <ForumOutlinedIcon className={iconClassName} />
}

const HCCategoryItem = ({ faqCategoryId, heading, description, embedded, icon }) => {
  return (
    <HCItemContainer
      to={
        Boolean(embedded)
          ? `/help-center-embedded/category/${faqCategoryId}`
          : `/help-center/category/${faqCategoryId}`
      }
    >
      <HCIconWrapper>{icon}</HCIconWrapper>
      <HCItemText heading>{heading}</HCItemText>
      <HCItemText>{description}</HCItemText>
    </HCItemContainer>
  )
}

export const HCTalkToUsCard = () => {
  return (
    <HCItemTalkToUsContainer>
      <HCTalkToUsHeader>
        <HCItemTalkToUsIconContainer>
          <ForumOutlinedIcon />
        </HCItemTalkToUsIconContainer>
        <HCTalkToUsContent>
          <h3>Talk to an expert</h3>
          <p>Get personalized assistance from our support team</p>
        </HCTalkToUsContent>
      </HCTalkToUsHeader>
      <HCTalkToUsActions>
        <HCItemTalkToUsALink href={APP_CONSTANTS.SUPPORT_SCHEDULE_CALL}>
          <PhoneOutlinedIcon />
          <div>Schedule a Call</div>
        </HCItemTalkToUsALink>
        <HCItemTalkToUsALink href={`mailto:${APP_CONSTANTS.SUPPORT_EMAIL}`}>
          <EmailOutlinedIcon />
          <div>Send an Email</div>
        </HCItemTalkToUsALink>
      </HCTalkToUsActions>
      <HCTalkToUsFooter>
        <div style={{ marginBottom: '8px' }}>Need immediate help? Contact us at:</div>
        <a href={`mailto:${APP_CONSTANTS.SUPPORT_EMAIL}`}>{APP_CONSTANTS.SUPPORT_EMAIL}</a>
      </HCTalkToUsFooter>
    </HCItemTalkToUsContainer>
  )
}
